import { componentsIconName } from '../IconNames';
import { SvgComponentsIcons, SvgComponentsLocalizedIcons } from '../svgIconSets/components';
import { initializeSvgIconSet } from '../initializeSvgIconSet';
/**
 * @deprecated Use function `getComponentsIcon` instead.
 */ export const useComponentsIcon = componentsIconName;
/**
 * Type-safe access of the icon names of this set, with the registration of the iconSet as a side effect
 */ export const getComponentsIcon = componentsIconName;
/**
 * Side effect to register the icon set when this file is referenced, such as when the type-safe functions are used
 */ initializeSvgIconSet(SvgComponentsIcons);
initializeSvgIconSet(SvgComponentsLocalizedIcons);
